import {Page} from 'utils/page-utils';
import CMSUtils, {CustomTypes} from 'utils/cms';

// Takes the route and returns the prismic slug needed
// to retrieve page data (ie. path/some-page => path_some-page)
// can also work on nested paths (ie. path/subpath/some-page => path_subpath_some-page)
export const cleanedSlug = pathname => {
    const parsedPathName = pathname.slice(1).replace(/\//g, '_');
    const trailingUnderScoreCheck = parsedPathName.endsWith('_')
        ? parsedPathName.slice(0, -1)
        : parsedPathName;

    return trailingUnderScoreCheck;
};

const pageType = Page.MARKETING;

const getInitialState = async ({state, cookies, route}) => ({
    ...state,
    page: await CMSUtils.getPageData({
        cookies,
        slug: cleanedSlug(route.location.pathname),
        customType: CustomTypes.MARKETING_PAGES,
        pageType,
    }),
});

export default getInitialState;
